import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { otherDeductionsDetailInputList2 } from '../../../../common/data';

import ItemTitleSection from '../../../../components/ItemTitleSection';

import DetailTitleSection from '../../../../components/DetailTitleSection';
import Button from '../../../../components/common/Button';
import DetailButtonSection from '../../../../components/DetailButtonSection';
import {
  handleAddButton,
  handleChange,
  handleDeleteButton,
  isValidate02,
  renderField,
  renderField01,
} from '../util';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { useSelector } from 'react-redux';
import { getBankList } from '../../../common/commonSlice';
import { getOtherDeductionsData2, saveOtherDeductionsData } from '../otherDeductionsSlice';
import { formatDate, getAlertMessageFunction, magamCertifyCheck } from '../../../../common/Util';

//장기집합투자증권
const Type2 = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/other');
  const { t: tCommon } = useTranslation('common');
  const [dataList, setDataList] = useState([]);
  const { s11_2Data, detailReload } = useSelector(state => state.otherDeductions);
  const { bankList, isMagam, isCertify } = useSelector(state => state.common);
  const inputFields = otherDeductionsDetailInputList2(t);
  const initData = {
    htmSeq: '',
    htmFlag: '', //F : 장기 집합투자증권, C : 청년형 집합투자증권
    htmKFlag: '2',
    htm002: '', //금융기관
    htm003: '', //계좌번호
    htm004: '', //납입금액
    htm012: '', //가입일자
    htm013: '', //계약기간월수
  };

  useEffect(() => {
    if (isOpen && bankList.length === 0) {
      // if (bankList.length === 0) {
      dispatch(getBankList());
    }
  }, [bankList]);

  useEffect(() => {
    //초기는 메인에서 받는다. 삭제, 저장할때만 다시받음
    if (detailReload != -1) {
      dispatch(getOtherDeductionsData2());
    }
  }, [detailReload]);

  useEffect(() => {
    if (isOpen) {
      const formattedData = s11_2Data
        ?.map(item => {
          return {
            htmSeq: item.htmSeq,
            htmFlag: item.htmFlag?.trim(),
            htmKFlag: item.htmKFlag,
            htmPDFFlag: item.htmPDFFlag || '',
            htmType: item.htmType || '',
            htm002: item.htm002 || '',
            htm003: item.htm003 || '',
            htm004: item.htm004 || '',
            htm012: item.htm012 || '',
            htm013: item.htm013 || '',
          };
        })
        .sort((a, b) => {
          // htmSeq를 순서대로 정렬
          return Number(a.htmSeq) - Number(b.htmSeq);
        });
      setDataList(formattedData);
    }
  }, [s11_2Data, isOpen]);

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    if (!isValidate02(dataList, t)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();
    let formData = dataList.map(item => {
      return {
        ...item,
        htm012: formatDate(item.htm012.replaceAll('-', '')),
      };
    });

    try {
      const resultAction = await dispatch(saveOtherDeductionsData({ formData })).unwrap();

      if (resultAction.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
      console.error('저장 중 오류 발생: ', error);
    }
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={`${t('detail.type2.title')}`} />
        {dataList.length > 0 &&
          dataList.map((data, index) => {
            //국세청자료
            let disabled = data?.htmType == '1' && data?.htmPDFFlag == '2' && data?.htmKFlag == '1';
            return (
              <div key={index} className="displayFlexColumn" style={{ gap: '10px' }}>
                <ItemTitleSection
                  title={t('detail.type2.title') + (index + 1)}
                  buttonIcon={!disabled}
                  handleDeleteButton={() => {
                    if (!magamCertifyCheck(isMagam, isCertify)) {
                      return;
                    }
                    handleDeleteButton(
                      index,
                      setDataList,
                      tCommon,
                      dispatch,
                      dataList,
                      data.htmFlag || 'F',
                    );
                  }}
                />

                <div className="displayFlexColumn" style={{ gap: '16px' }}>
                  {inputFields.map(field => (
                    <div key={field.key}>
                      {renderField01(
                        field,
                        data[field.key],
                        value => handleChange(index, field.key, value, setDataList, dispatch),
                        '1',
                        bankList,
                        disabled,
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}

        <Button
          value={t('detail.type2.addButton')}
          style={{ width: '100%' }}
          addButton
          color="sub"
          onClick={() => {
            if (!magamCertifyCheck(isMagam, isCertify)) {
              return;
            }
            handleAddButton(setDataList, initData);
          }}
        />

        <DetailButtonSection onClose={onClose} onSave={handleSave} />
      </div>
    </SlideRightDialog>
  );
};

export default Type2;
